import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import Button from 'eventbrite_design_system/button/Button';

import Image from '../Image';
import Template from './Template';
import Pricing from './Pricing';
import PricingCallout from './PricingCallout';
import { PRICING_PROP_TYPES } from '../../constants/componentPropTypes';
import { ASSORTMENT_TAX_PROP_TYPES } from '../../constants/pricingPropTypes';

const BannerContent = ({
    heading,
    hidePricing,
    pricingCalloutAction,
    pricingCalloutText,
    pricingCalloutDescriptionPrimary,
    pricingCalloutDescriptionSecondary,
    price,
    priceDescription,
    perPaidTicketText,
    secondaryHeading,
    CTA,
    CTAStyle,
    onClick,
    taxLabel,
}) => (
    <section className="eds-l-pad-vert-16 eds-g-cell eds-g-cell-10-12 eds-g-cell-md-6-12 eds-g-cell-mw-5-12 eds-g-offset-1-12">
        <h1 className="eds-text-bl eds-text-weight--semibold eds-text-color--mellow-pink">
            {heading}
        </h1>
        <h2 className="eds-text-hl eds-text-color--white eds-l-mar-top-2">
            {secondaryHeading}
        </h2>
        {hidePricing ? (
            <PricingCallout
                onClick={pricingCalloutAction}
                linkText={pricingCalloutText}
                descriptionPrimary={pricingCalloutDescriptionPrimary}
                descriptionSecondary={pricingCalloutDescriptionSecondary}
            />
        ) : (
            <Pricing
                price={price}
                taxLabel={taxLabel}
                priceDescription={priceDescription}
                perPaidTicketText={perPaidTicketText}
                priceColor="white"
                priceTextColor="grey-400"
            />
        )}
        <div className="eds-l-mar-top-4 eds-g-cell eds-g-cell-md-6-12 eds-g-cell--has-overflow">
            <Button style={CTAStyle} disabled={!CTAStyle} onClick={onClick}>
                {CTA}
            </Button>
        </div>
    </section>
);

export default class MainBanner extends PureComponent {
    static propTypes = {
        ...PRICING_PROP_TYPES,
        /*
        Main title
        */
        heading: translationPropType,
        /*
        Secondary heading
        */
        secondaryHeading: translationPropType,
        /*
        Path to image
        */
        imagePath: PropTypes.string,
        /*
        Path to image
        */
        illustration: PropTypes.string,
        /*
        CTA for button
        */
        CTA: translationPropType,
        /*
        CTA style for button
        */
        CTAStyle: PropTypes.string,
        /*
        Exta tax label
        */
        taxLabel: ASSORTMENT_TAX_PROP_TYPES,
    };

    render() {
        const {
            CTA,
            CTAStyle,
            heading,
            hidePricing,
            pricingCalloutAction,
            pricingCalloutText,
            pricingCalloutDescriptionPrimary,
            pricingCalloutDescriptionSecondary,
            illustration,
            imagePath,
            bgImgHeight,
            secondaryHeading,
            perPaidTicketText,
            price,
            priceDescription,
            onClick,
            taxLabel,
        } = this.props;
        let mainBannerImg = <Image illustration={illustration} />;

        if (imagePath) {
            mainBannerImg = (
                <Image
                    isFullWidth={false}
                    imagePath={imagePath}
                    height={bgImgHeight}
                />
            );
        }

        return (
            <div className="eds-g-grid">
                <Template hasPadding={false} bgColor="grey-900">
                    <BannerContent
                        CTA={CTA}
                        CTAStyle={CTAStyle}
                        heading={heading}
                        hidePricing={hidePricing}
                        pricingCalloutAction={pricingCalloutAction}
                        pricingCalloutText={pricingCalloutText}
                        pricingCalloutDescriptionPrimary={
                            pricingCalloutDescriptionPrimary
                        }
                        pricingCalloutDescriptionSecondary={
                            pricingCalloutDescriptionSecondary
                        }
                        secondaryHeading={secondaryHeading}
                        perPaidTicketText={perPaidTicketText}
                        price={price}
                        taxLabel={taxLabel}
                        priceDescription={priceDescription}
                        onClick={onClick}
                    />
                    <section className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-5-12 eds-align--center">
                        {mainBannerImg}
                    </section>
                </Template>
            </div>
        );
    }
}
